__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@bonusly/monarch";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bonusly/application", "1.0.1", () => (Promise.all([__webpack_require__.e(706), __webpack_require__.e(94)]).then(() => (() => (__webpack_require__(5094))))));
			register("@bonusly/design-system", "1.1.2", () => (Promise.all([__webpack_require__.e(706), __webpack_require__.e(424), __webpack_require__.e(707), __webpack_require__.e(574)]).then(() => (() => (__webpack_require__(9424))))));
			register("@bonusly/http-client", "1.0.1", () => (Promise.all([__webpack_require__.e(958), __webpack_require__.e(706), __webpack_require__.e(877), __webpack_require__.e(425)]).then(() => (() => (__webpack_require__(189))))));
			register("@bonusly/http", "1.2.0", () => (__webpack_require__.e(615).then(() => (() => (__webpack_require__(4615))))));
			register("@bonusly/who-am-i", "2.3.4", () => (Promise.all([__webpack_require__.e(732), __webpack_require__.e(706), __webpack_require__.e(987), __webpack_require__.e(892)]).then(() => (() => (__webpack_require__(5892))))));
			register("@chakra-ui/react", "2.8.2", () => (Promise.all([__webpack_require__.e(490), __webpack_require__.e(706), __webpack_require__.e(830), __webpack_require__.e(368), __webpack_require__.e(16), __webpack_require__.e(518)]).then(() => (() => (__webpack_require__(3490))))));
			register("@datadog/browser-rum", "5.9.0", () => (__webpack_require__.e(822).then(() => (() => (__webpack_require__(7822))))));
			register("@emotion/react", "11.11.3", () => (Promise.all([__webpack_require__.e(924), __webpack_require__.e(706), __webpack_require__.e(896)]).then(() => (() => (__webpack_require__(9924))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(706), __webpack_require__.e(368), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(8479))))));
			register("@tanstack/react-query", "4.36.1", () => (Promise.all([__webpack_require__.e(468), __webpack_require__.e(706)]).then(() => (() => (__webpack_require__(5776))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(803).then(() => (() => (__webpack_require__(5803))))));
			register("crypto-js", "4.2.0", () => (Promise.all([__webpack_require__.e(449), __webpack_require__.e(633)]).then(() => (() => (__webpack_require__(6449))))));
			register("framer-motion", "10.18.0", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(706)]).then(() => (() => (__webpack_require__(2483))))));
			register("i18next-http-backend", "2.4.2", () => (__webpack_require__.e(11).then(() => (() => (__webpack_require__(1671))))));
			register("i18next", "22.5.1", () => (__webpack_require__.e(872).then(() => (() => (__webpack_require__(9872))))));
			register("intl-pluralrules", "1.3.1", () => (__webpack_require__.e(367).then(() => (() => (__webpack_require__(367))))));
			register("lodash.capitalize", "4.2.1", () => (__webpack_require__.e(271).then(() => (() => (__webpack_require__(271))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(749), __webpack_require__.e(706)]).then(() => (() => (__webpack_require__(5749))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(71), __webpack_require__.e(706)]).then(() => (() => (__webpack_require__(71))))));
			register("react-router-dom", "6.22.1", () => (Promise.all([__webpack_require__.e(925), __webpack_require__.e(706), __webpack_require__.e(830)]).then(() => (() => (__webpack_require__(5925))))));
			register("react", "18.2.0", () => (__webpack_require__.e(969).then(() => (() => (__webpack_require__(969))))));
			initExternal(2419);
			initExternal(5527);
			initExternal(6915);
			initExternal(2318);
			initExternal(5082);
			initExternal(6805);
			initExternal(4845);
			initExternal(463);
			initExternal(6923);
			initExternal(2004);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};